import getStore from '../store/store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('updateCalendarEventSelections', function (selectedIds) {
    var optionStore = getStore();
    optionStore.selectedCalendarIds = selectedIds;
});
//# sourceMappingURL=updateCalendarEventSelections.js.map